import React, {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {Link} from 'react-router-dom'
import {
	FiChevronRight,
} from 'react-icons/fi'
import {useTranslation} from 'react-i18next'
import styled, { css } from 'styled-components'
import { IconDown, IconUp } from '../icons'

const ItemStyles = css`
	width: 100%;
	box-sizing: border-box;
	padding: 14px 20px;
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	gap: 16px;
	color: rgba(255, 255, 255, 0.60);
	font-family: "Basis Grotesque Pro";
	font-family: inherit;
	font-size: 16px;
	line-height: 120%; /* 19.2px */
	/* letter-spacing: 0.48px; */
	outline: none;
  cursor: pointer;
	border: 1px solid transparent;
	transition: all 0.4s;

	/*&:after {
		content: "";
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		width: 4px;
		background: rgba(33, 150, 243, 1);
	}*/

	&[data-active="true"], &:hover {
		//color: rgba(33, 150, 243, 1);
		color: rgba(255, 255, 255, 1);
		background: rgba(50, 160, 229, 0.10);
		backdrop-filter: blur(50px);
		border: 1px solid rgba(50, 160, 229, 0.20);

		/*&:after {
			display: block;
		}*/
	}

	&[data-hidden] + ul {
		padding-left: 36px;
	}

	&[data-hidden="true"] + ul {
		display: none;
	}
`

const ItemLink = styled(Link)`
	${ItemStyles}
`

const ItemIcon = styled.span`
	display: inline-block;
`

const ItemText = styled.span`
	display: inline-block;
	overflow: hidden;
	width: 100%;
	opacity: 1;
	text-wrap: nowrap;
	text-align: left;
	text-overflow: ellipsis;
	transition: opacity 0.5s 0s ease-in-out, width 0.5s 0s ease-in-out;
`

const ItemSpace = styled.button`
	${ItemStyles}
`

const scrollToTop = () => {
	window.scrollTo(0, 0)
}

export const Item = ({
											 collapsed,
											 hidden,
											 setHidden,
											 url,
											 icon,
											 title,
											 badge,
											 items,
											 closeSubMenusFlag
}) => {
	const {t} = useTranslation();
	let location = useLocation()
	let {pathname} = {...location}

	useEffect(() => {
		collapsed && setHidden('')
	}, [collapsed, closeSubMenusFlag]);

	if (items.length === 0) {
		return (
			<ItemLink
				to={url}
				data-active={pathname === url}
				data-collapsed={collapsed}
				onClick={() => {
					scrollToTop();

					if (collapsed || url.split('/').length < 3) {
						//console.log('ItemLink click: ', {title})
						setHidden(`${title}+${url}`)
					}
				}}
			>
				<ItemIcon>{ icon ?? null }</ItemIcon>
				<ItemText data-collapsed={collapsed} >{ t(title) }</ItemText>
			</ItemLink>
		)
	}

	return (
		<ItemSpace
			data-active={pathname.split('/')?.[1] === url?.slice(1)}
			data-collapsed={collapsed}
			data-hidden={hidden}
			className={`${hidden ? 'hidden-sibling' : 'open-sibling'}`}
			onClick={() => {
				//console.log('ItemSpace click: ', {title})
				setHidden(`${title}+${url}`)
			}}
		>
			<ItemIcon>{ icon ?? null }</ItemIcon>
			<ItemText data-collapsed={collapsed} >{ t(title) }</ItemText>
			{
				collapsed
					? null
					: hidden
						? (<IconDown size={20} />)
						: (<IconUp size={20} />)
			}
		</ItemSpace>
	)
}

export default Item
